<template>
<v-main style="height: 50rem ;">
    <v-img height="50rem" :src="require('@/assets/YP2A7469 copy.webp')" class="hero">
    <div style="margin-top:-1em" class="filter">

    <v-container >
    <v-row class="my-12" >

      <v-col xl="6" lg="6" md="5" sm="12">
        <div class="hidden-md-and-up">
          <v-img style="padding:1px;" :src="require('../assets/Brand/Maryud-Logo-Yellow.webp')" contain height="15em"></v-img>
        <h1 class="mt-10n white--text text-center">- <b> 103 FM </b> - </h1>
        
        </div>
        <h2 class="white--text" style=" padding:1px;margin:2.5em 0em 10em 3em">
          <v-img height="0.8em" width="0.8em" contain :src="require('../assets/+.webp')"></v-img>
          {{$t('hero')}}
         </h2>

      </v-col>
      <v-col xl="4" lg="4" md="5" sm="12" class="hidden-sm-and-down justify-center" >
        <v-container class="justify-center mt-10 ml-10">
    

        <v-img style="padding:1px;" :src="require('../assets/Brand/Maryud-Logo-Yellow.webp')" contain height="15em"></v-img>
        <h1 class="mt-10n white--text text-center" style="margin-bottom:30em">- <b> 103 FM </b> - </h1>
         </v-container>
        </v-col>
    </v-row>
    </v-container>
    </div>
  </v-img>
               <!-- <audio controls >
                 <source src="http://pollux.shoutca.st:8709/stream" type="audio/mp3">
               </audio> -->
 </v-main>
</template>


<script>
import store from '../store/index'

export default {
    name:'Hero',
    data:()=>({
      sound: new Audio('http://pollux.shoutca.st:8709/stream')
     
    }),
    methods:{
      playSound(){
         store.dispatch('playSound')
       },
      volumeUp(){
           store.state.stream.volume =  store.state.stream.volume + 0.1;
         },
         volumeDown(){
           store.state.stream.volume =  store.state.stream.volume - 0.1;
         }
    }
    
}
</script>
<style lang="scss">
@import '../scss/hero.scss';
</style>